import { useCallback, useState } from 'react'
import Select from '@mui/joy/Select'
import Option from '@mui/joy/Option'
import axios from 'axios'
import Button from '@mui/joy/Button'
import {
    Grid,
    Input,
    Box,
    Typography,
    FormLabel,
    FormControl,
    Autocomplete,
} from '@mui/joy'
import dynamic from 'next/dynamic'
import { toast } from 'react-hot-toast'
import Section from '../../Section/Section'
import { Center } from '../../Center'
import { Content } from '../../Content'
import { Flex } from '../../Flex'

const ReCAPTCHA = dynamic(() => import('react-google-recaptcha'), {
    ssr: false,
})

export const CFL_LIST = [
    {
        value: 'Yes',
        label: 'Yes',
    },
    {
        value: 'No',
        label: 'No',
    },
    {
        value: "I'm not based in CA.",
        label: "I'm not based in CA.",
    },
]

export const PRIVACY_LIST = [
    {
        value: 'Yes',
        label: 'Yes',
    },
    {
        value: 'No',
        label: 'No',
    },
]

export const PARTNERSHIP_LIST = [
    {
        value: 'Lending Partner',
        label: "Lending Partner (I'm a lender and want to fund EZ Capital's deals)",
    },
    {
        value: 'Referral Partner',
        label: "Referral Partner (My primary business isn't lending, but my customers need financing)",
    },
    {
        value: 'Affiliate',
        label: "Affiliate (I'm a marketer and can drive online leads to EZ Capital)",
    },
]

export const DIRECT_LENDER_LIST = [
    {
        value: 'Yes',
        label: 'Yes',
    },
    {
        value: 'No',
        label: 'No',
    },
]

export const PRODUCT_OFFER_LIST = [
    {
        value: 'Business Line of Credit',
        label: 'Business Line of Credit',
    },
    {
        value: 'Business Term Loan',
        label: 'Business Term Loan',
    },
    {
        value: 'Merchant Cash Advance',
        label: 'Merchant Cash Advance',
    },
    {
        value: 'Business Credit Card',
        label: 'Business Credit Card',
    },
    {
        value: 'SBA Loans',
        label: 'SBA Loans',
    },
    {
        value: 'Other',
        label: 'Other',
    },
]

export const HERE_FROM_LIST = [
    {
        value: 'Online Search',
        label: 'Online Search',
    },
    {
        value: 'Online Video',
        label: 'Online Video',
    },
    {
        value: 'Online Ads',
        label: 'Online Ads',
    },
    {
        value: 'Email',
        label: 'Email',
    },
    {
        value: 'Referral',
        label: 'Referral',
    },
    {
        value: 'Social Media',
        label: 'Social Media',
    },
    {
        value: 'Other',
        label: 'Other',
    },
]

export default function Form() {
    // const [sendEmail, { loading }] = useMutation(MUTATION_SEND_EMAIL)
    const [isPassed, setIsPassed] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [error, setError] = useState(null)
    const [productOffer, setProductOffer] = useState([])
    // console.log(loading, data?.sendEmail?.message);
    const handleSubmit = useCallback(
        async (event) => {
            event.preventDefault()

            if (isLoading || !isPassed) return

            setIsLoading(true)
            const formData = new FormData(event.target)

            const firstName = formData.get('firstName')
            const lastName = formData.get('lastName')
            const email = formData.get('email')
            const phoneNumber = formData.get('phoneNumber')

            const businessName = formData.get('businessName')
            const registrationState = formData.get('RegistrationState')
            const businessAddress = formData.get('businessAddress')
            const businessCity = formData.get('businessCity')
            const businessState = formData.get('businessState')
            const businessZipcode = formData.get('businessZipcode')

            const CFL = formData.get('CFL')
            const businessWebsite = formData.get('businessWebsite')
            const privacy = formData.get('privacy')
            const partnership = formData.get('partnership')
            const isDirectLender = formData.get('isDirectLender')
            // const productsOffer = formData.get('productsOffer')
            const primaryBusiness = formData.get('primaryBusiness')
            const hereFrom = formData.get('hereFrom')

            // const fromAddress = 'info@menusifu.com'
            // const toAddress = 'info@menusifu.com'
            const subject = 'Become an EZ Capital Partner'
            const body =
                `First Name: ${firstName}\n` +
                `Last Name: ${lastName}\n` +
                `Phone Number: ${phoneNumber}\n` +
                `Business Name: ${businessName}\n` +
                `Registration State: ${registrationState}\n` +
                `Business Address: ${businessAddress}\n` +
                `Business City: ${businessCity}\n` +
                `Business State: ${businessState}\n` +
                `Business Zipcode: ${businessZipcode}\n` +
                `CFL: ${CFL}\n` +
                `Business Website: ${businessWebsite}\n` +
                `Privacy: ${privacy}\n` +
                `Partnership : ${partnership}\n` +
                `isDirectLender: ${isDirectLender}\n` +
                `Products Offer: ${productOffer}\n` +
                `Primary Business: ${primaryBusiness}\n` +
                `Here From: ${hereFrom}`

            try {
                const result = await axios.post(
                    `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/contact-form-7/v1/contact-forms/1236/feedback`,
                    {
                        'your-email': email,
                        'your-subject': subject,
                        'your-message': body,
                    },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data;',
                        },
                    }
                )

                if (result?.data?.status === 'mail_sent') {
                    toast((t) => (
                        <Flex>
                            <Typography pr={2}>
                                Congrats! Your submission was complete and one
                                of our team members will contract you in the
                                next few days.
                            </Typography>
                            <Button
                                variant="outlined"
                                onClick={() => toast.dismiss(t.id)}
                            >
                                Dismiss
                            </Button>
                        </Flex>
                    ))
                    event.target.reset()
                } else {
                    setError(result?.data?.message)
                }
            } catch (_error) {
                // eslint-disable-next-line no-console
                console.warn(_error)
            } finally {
                setIsLoading(false)
            }
        },
        [isLoading, isPassed, productOffer]
    )

    const handleOnChange = useCallback(() => {
        setIsPassed(true)
    }, [])

    return (
        <Section>
            <Center>
                <Content>
                    <form method="post" onSubmit={handleSubmit}>
                        <Typography
                            component="h2"
                            fontWeight={700}
                            // fontFamily="Lato"
                            fontSize={{
                                md: '50px',
                                sm: '38px',
                                xs: '32px',
                            }}
                            sx={{
                                color: '#0d417d',
                                letterSpacing: '-0.5px',
                                lineHeight: 1.1,
                            }}
                        >
                            Become an EZ Capital Partner
                        </Typography>
                        <Typography level="p" paddingBottom={12}>
                            Earn a commission on each funded application that
                            you or your clients start with EZ Capital!
                        </Typography>
                        {/* {data && (
                            <Alert pb={6}>{data?.sendEmail?.message}</Alert>
                        )} */}
                        <Typography level="h6" mb={4}>
                            Partner Contract Info
                        </Typography>
                        <Grid container px={0} spacing={4} mb={2}>
                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>First Name</FormLabel>
                                    <Input
                                        name="firstName"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>Last Name</FormLabel>
                                    <Input
                                        name="lastName"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required maxlength={256}>
                                        Enter your email address
                                    </FormLabel>
                                    <Input
                                        name="email"
                                        size="lg"
                                        required
                                        type="email"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required maxlength={256}>
                                        Business Phone Number
                                    </FormLabel>
                                    <Input
                                        name="phoneNumber"
                                        size="lg"
                                        required
                                        type="tel"
                                        placeholder="000-000-0000"
                                        slotProps={{
                                            input: {
                                                pattern:
                                                    '[0-9]{3}-[0-9]{3}-[0-9]{4}',
                                            },
                                        }}
                                        // pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Typography level="h6" mb={4}>
                            Partnership opportunities are limited to U.S.-based
                            businesses
                        </Typography>
                        <Grid container px={0} spacing={4} mb={2}>
                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>
                                        Legal Name of Business
                                    </FormLabel>
                                    <Input
                                        name="businessName"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>
                                        State of Business Registration
                                    </FormLabel>
                                    <Input
                                        name="registrationState"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel required>
                                        Business Street Address
                                    </FormLabel>
                                    <Input
                                        name="businessAddress"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>
                                        Business City
                                    </FormLabel>
                                    <Input
                                        name="businessCity"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>
                                        Business State
                                    </FormLabel>
                                    <Input
                                        name="businessState"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>
                                        Business Zipcode
                                    </FormLabel>
                                    <Input
                                        name="businessZipcode"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormLabel mb={1}>
                                    If based in California, do you have a CFL?
                                </FormLabel>
                                <Select
                                    name="CFL"
                                    required
                                    size="lg"
                                    MenuProps={{
                                        style: { zIndex: 35001 },
                                    }}
                                >
                                    {CFL_LIST.map((item) => (
                                        <Option
                                            value={item.value}
                                            key={item.value}
                                        >
                                            {item.label}
                                        </Option>
                                    ))}
                                </Select>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel>Business Website</FormLabel>
                                    <Input
                                        name="businessWebsite"
                                        size="lg"
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel mb={1} required>
                                        Is your privacy policy and terms of use
                                        published on your website?
                                    </FormLabel>
                                    <Select
                                        name="privacy"
                                        required
                                        size="lg"
                                        MenuProps={{
                                            style: { zIndex: 35001 },
                                        }}
                                    >
                                        {PRIVACY_LIST.map((item) => (
                                            <Option
                                                value={item.value}
                                                key={item.value}
                                            >
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel mb={1} required>
                                        What type of partnership are you
                                        interested in?
                                    </FormLabel>
                                    <Select
                                        name="partnership"
                                        required
                                        size="lg"
                                        MenuProps={{
                                            style: { zIndex: 35001 },
                                        }}
                                    >
                                        {PARTNERSHIP_LIST.map((item) => (
                                            <Option
                                                value={item.value}
                                                key={item.value}
                                            >
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel mb={1} required>
                                        Are You a Direct Lender?
                                    </FormLabel>
                                    <Select
                                        name="isDirectLender"
                                        required
                                        size="lg"
                                        MenuProps={{
                                            style: { zIndex: 35001 },
                                        }}
                                    >
                                        {DIRECT_LENDER_LIST.map((item) => (
                                            <Option
                                                value={item.value}
                                                key={item.value}
                                            >
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* need multi select
                            need multi select
                            need multi select */}
                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel mb={1} required>
                                        What loan product(s) does your company
                                        offer?
                                    </FormLabel>
                                    <Autocomplete
                                        multiple
                                        name="productOffer"
                                        // required
                                        size="lg"
                                        value={productOffer}
                                        onChange={(_, value) =>
                                            setProductOffer(value)
                                        }
                                        MenuProps={{
                                            style: { zIndex: 35001 },
                                        }}
                                        options={PRODUCT_OFFER_LIST}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={6}>
                                <FormControl>
                                    <FormLabel required>
                                        What is Your Primary Business?
                                    </FormLabel>
                                    <Input
                                        name="primaryBusiness"
                                        size="lg"
                                        required
                                        maxlength={256}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid xs={12} sm={12} md={12}>
                                <FormControl>
                                    <FormLabel required mb={1}>
                                        Where Did You Hear About Us?
                                    </FormLabel>
                                    <Select
                                        name="hereFrom"
                                        required
                                        size="lg"
                                        slotProps={{
                                            listbox: {
                                                sx: {
                                                    position: 'absolute',

                                                    zIndex: '35001!important',
                                                },
                                            },
                                        }}
                                    >
                                        {HERE_FROM_LIST.map((item) => (
                                            <Option
                                                value={item.value}
                                                key={item.value}
                                            >
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Box mb={3}>
                            <ReCAPTCHA
                                sitekey={
                                    process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
                                }
                                onChange={handleOnChange}
                            />
                        </Box>
                        <Button
                            size="lg"
                            type="submit"
                            loading={isLoading}
                            disabled={!isPassed}
                        >
                            Submit
                        </Button>
                    </form>
                </Content>
            </Center>
        </Section>
    )
}
